import smLogo from "@assets/images/smo-blue.svg";
import smLoginImage from "@assets/images/smop-login.svg";
import { makeStyles } from "@material-ui/core/styles";
import { useSavedAccount } from "@saleor/components/AppLayout/SavedAccountContext";
import useNavigator from "@saleor/hooks/useNavigator";
import useUser from "@saleor/hooks/useUser";
import React, { useEffect, useState } from "react";
import SVG from "react-inlinesvg";

import LoginPage, { FormData } from "../components/LoginPage";
import { passwordResetUrl } from "../urls";
const useStyles = makeStyles(
  theme => ({
    logo: {
      display: "block",
      height: "70px",
      marginRight: "1rem"
    },
    logoText: {
      fontSize: "1.5rem"
    },
    logoWrapper: {
      alignItems: "center",
      display: "flex",
      height: 70,
      marginBottom: theme.spacing(3)
    },
    mainPanel: {
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(2)
      },
      display: "flex",
      flexDirection: "column",
      height: "100vh",
      justifyContent: "center",
      padding: theme.spacing(6),
      width: "100vw"
    },
    mainPanelContent: {
      [theme.breakpoints.up("xs")]: {
        width: "100%"
      },
      [theme.breakpoints.up("sm")]: {
        width: 328
      },
      "@media (min-width: 1440px)": {
        display: "flex",
        width: 800
      },
      background: "#fff",
      border: "1px solid #c7c7c7",
      margin: "auto",
      padding: "2rem",
      position: "relative",
      width: "100%"
    },
    root: {
      [theme.breakpoints.up("lg")]: {
        gridTemplateColumns: "376px 1fr"
      },
      "@media (min-width: 1440px)": {
        gridTemplateColumns: "520px 1fr"
      },
      display: "grid",
      gridTemplateColumns: "1fr",
      height: "100vh",
      overflow: "hidden",
      width: "100vw"
    },
    sideLeft: {
      [theme.breakpoints.up("xs")]: {
        width: "100%"
      },
      "& svg": {
        [theme.breakpoints.up("xs")]: {
          height: "150px",
          marginBottom: theme.spacing(2),
          width: "280px"
        },
        "@media (min-width: 1440px)": {
          height: "215px"
        },
        display: "block"
      },
      "@media (min-width: 1440px)": {
        marginRight: "4rem",
        width: "50%"
      },
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-end"
    },
    sideRight: {
      width: "100%"
    }
  }),
  {
    name: "Layout"
  }
);

const LoginView: React.FC = () => {
  const navigate = useNavigator();
  const { login, userDetail, tokenAuthLoading } = useUser();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [hasError, setHasError] = useState(false);
  const { handleRemoveFromIgnoredAccounts } = useSavedAccount();
  const classes = useStyles({});

  const handleSubmit = (data: FormData) => {
    handleRemoveFromIgnoredAccounts(data.email);
    login(data.email, data.password);
    setIsSubmitted(true);
  };

  useEffect(() => {
    if (!tokenAuthLoading && isSubmitted && !userDetail) {
      setHasError(true);
    } else {
      setHasError(false);
    }

    return () => {
      setHasError(false);
    };
  }, [tokenAuthLoading]);

  return (
    <div className={classes.root}>
      <div className={classes.mainPanel}>
        <div className={classes.mainPanelContent}>
          <div className={classes.sideLeft}>
            <SVG src={smLoginImage} />
          </div>
          <div className={classes.sideRight}>
            <div className={classes.logoWrapper}>
              <img className={classes.logo} src={smLogo} />
              <p className={classes.logoText}>Welcome Back!</p>
            </div>
            <LoginPage
              error={!tokenAuthLoading && hasError}
              disableLoginButton={tokenAuthLoading}
              onPasswordRecovery={() => navigate(passwordResetUrl)}
              onSubmit={handleSubmit}
              canResetPassword={true}
              canRegister={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
LoginView.displayName = "LoginView";
export default LoginView;
